import React from 'react';
import SuggestionList from './SuggestionList';
import { useTranslation } from 'react-i18next';
import { debounce } from 'lodash';
import SearchInputIcon from '../assets/Search';
var UniversalSearch = function (_a) {
    var onChange = _a.onChange, data = _a.data, isOpen = _a.isOpen, equipmentRedirectPath = _a.equipmentRedirectPath, onBeforeRedirect = _a.onBeforeRedirect;
    var t = useTranslation().t;
    var vehiclesApiLoading = data.vehiclesApiLoading, customerApiLoading = data.customerApiLoading, communicatorApiLoading = data.communicatorApiLoading;
    return (React.createElement("div", { className: "universal-search sdds-body-02", id: "universalSearch_tour_id" },
        React.createElement("label", null,
            React.createElement("input", { onChange: debounce(onChange, 1000), type: "search", title: t("TS_core:SearchByVinChassiRegAliasCommunicatorIDsCustomerName"), placeholder: t("TS_core:SearchByVinChassiRegAliasCommunicatorIDsCustomerName") }),
            React.createElement("span", { className: 'searchInputIcon' },
                React.createElement(SearchInputIcon, null))),
        isOpen &&
            React.createElement(SuggestionList, { vehicles: data.vehicleList, customers: data.customerList, communications: data.communicationList, highlitedText: data.prefix, vehiclesApiLoading: vehiclesApiLoading, customerApiLoading: customerApiLoading, communicatorApiLoading: communicatorApiLoading, equipmentRedirectPath: equipmentRedirectPath, onBeforeRedirect: onBeforeRedirect })));
};
export default UniversalSearch;
